import {GetStaticProps, InferGetStaticPropsType} from 'next';
import React from 'react';

import Col from '../../../features/common/Col';
import {getCmsEntry} from '../../../features/strapi';
import {GeneralCalculator} from '../../../features/strapi/generated/components';
import {ApiCalculatorsSimpleCalculatorsSimple, ApiFooterFooter} from '../../../features/strapi/generated/contentTypes';
import {ProcessedValues} from '../../../features/strapi/types';
import CalculatorWrapper from '../../../features/tool/components/calculators/CalculatorWrapper';
import LargeScaleCalculator from '../../../features/tool/components/calculators/LargeScaleCalculator';
import ProductionCalculator from '../../../features/tool/components/calculators/ProductionCalculator';
import SmallScaleCalculator from '../../../features/tool/components/calculators/SmallScaleCalculator';
import Footer from '../../../features/tool/components/Footer';
import {getToolLayout} from '../../../features/tool/components/Layout';
import RichText from '../../../features/tool/components/RichText';
import {CALCULATOR_PARAMS, CALCULATOR_PROCESS_DATA_MAP} from '../../../features/tool/util/calculators.util';
import {buildStaticPropsResponse} from '../../../features/tool/util/dataFetch';
import {NextPageWithLayout} from '../../_app';

type Props = {
  footer: ProcessedValues<ApiFooterFooter>;
  calculatorsSimple: ProcessedValues<ApiCalculatorsSimpleCalculatorsSimple>;
};

const SimpleCalculatorPage: NextPageWithLayout<InferGetStaticPropsType<typeof getStaticProps>> = ({
  footer,
  calculatorsSimple,
}) => {
  return (
    <>
      <CalculatorWrapper calculator={calculatorsSimple.calculator as ProcessedValues<GeneralCalculator>}>
        <Col className={'mt-xs gap-md'}>
          <RichText className={'text-sm'} content={calculatorsSimple.small_scale_description} />
          <SmallScaleCalculator />
          <RichText className={'mt-sm text-sm'} content={calculatorsSimple.large_scale_description} />
          <LargeScaleCalculator />
          <RichText className={'mt-sm text-sm'} content={calculatorsSimple.production_description} />
          <ProductionCalculator />
        </Col>
      </CalculatorWrapper>
      <Footer data={footer} />
    </>
  );
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const {footer} = await getCmsEntry<ApiFooterFooter, 'footer'>({path: 'footer'});
  const {calculatorsSimple} = await getCmsEntry<ApiCalculatorsSimpleCalculatorsSimple, 'calculatorsSimple'>({
    path: 'calculators-simple',
    rootKey: 'calculatorsSimple',
    params: CALCULATOR_PARAMS,
    processDataMap: CALCULATOR_PROCESS_DATA_MAP,
  });

  return buildStaticPropsResponse({
    footer,
    calculatorsSimple,
  });
};

export default SimpleCalculatorPage;

SimpleCalculatorPage.getLayout = getToolLayout;

SimpleCalculatorPage.title = 'Calculators';
